import { render, staticRenderFns } from "./POITableComponent.vue?vue&type=template&id=ebf9d36c&scoped=true"
import script from "./POITableComponent.js?vue&type=script&lang=js&external"
export * from "./POITableComponent.js?vue&type=script&lang=js&external"
import style0 from "./POITableComponent.vue?vue&type=style&index=0&id=ebf9d36c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf9d36c",
  null
  
)

export default component.exports